var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1244a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c3f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032a67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd34f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb2f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 0h8.38095238v.76190476h-8.38095238zm0 1.52380952h8.38095238v.76190477h-8.38095238zm0 1.52380953h8.38095238v.76190476h-8.38095238zm0 1.52380952h8.38095238v.76190476h-8.38095238zm-7.61904762 1.52380953h16v.76190476h-16zm0 1.52380952h16v.76190476h-16zm0 1.52380952h16v.76190476h-16zm0 1.52380956h16v.7619047h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h9.142857v6.095238h-9.142857z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.23705522 1.26239413c-.2072032-.07728893-.43148114-.11953699-.66562665-.11953699-1.05197095 0-1.9047619.85279096-1.9047619 1.90476191s.85279095 1.9047619 1.9047619 1.9047619c.23414551 0 .45842345-.04224805.66562665-.11953699-.3911536.3131878-.88746919.50048937-1.42753141.50048937-1.26236514 0-2.28571429-1.02334914-2.28571429-2.28571428 0-1.26236515 1.02334915-2.28571429 2.28571429-2.28571429.54006222 0 1.03637781.18730158 1.42753141.50048937zm.85818288 2.40998681-.66115618.74814305.17269765-.98337227-.99714591-.05045315.87650662-.47810212-.58226444-.8110571.92028823.38718867.27107403-.9609185.27107402.9609185.92028823-.38718867-.58226444.8110571.87650662.47810212-.99714591.05045315.17269765.98337227z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.0f038a996fc67ed4eae60099f1f254ed.svg";
export { ForwardRef as ReactComponent };